import styles from './Heading.module.css';
import { getClasses } from '@/_utils/classnames';
import type { FC } from 'react';
import type { HeadingProps } from './Heading.types';

export const Heading: FC<HeadingProps> = ({
  children,
  className,
  isSameLine,
  lineClamp,
  breakWords,
  color = 'primary',
  level = 1,
  'data-testid': dataTestId,
}) => {
  const headingClasses: string = getClasses(styles.heading, className, {
    'text-accent': color === 'accent',
    'text-caution': color === 'caution',
    'text-critical': color === 'critical',
    'text-disabled': color === 'disabled',
    'text-primary': color === 'primary',
    'text-secondary': color === 'secondary',
    'text-success': color === 'success',
    h1: level === 1,
    h2: level === 2,
    h3: level === 3,
    h4: level === 4,
    h5: level === 5,
    h6: level === 6,
    h7: level === 7,
    [styles.headingSameLine]: isSameLine,
    [styles.headingBreakWords]: breakWords,
    [styles.headingLineClamp]: !!lineClamp,
    [styles.headingLineClamp1]: lineClamp === 1,
    [styles.headingLineClamp2]: lineClamp === 2,
    [styles.headingLineClamp3]: lineClamp === 3,
  });

  // prettier-ignore
  switch (level) {
    case 1: return <h1 className={headingClasses} data-testid={dataTestId}>{children}</h1>;
    case 2: return <h2 className={headingClasses} data-testid={dataTestId}>{children}</h2>;
    case 3: return <h3 className={headingClasses} data-testid={dataTestId}>{children}</h3>;
    case 4: return <h4 className={headingClasses} data-testid={dataTestId}>{children}</h4>;
    case 5: return <h5 className={headingClasses} data-testid={dataTestId}>{children}</h5>;
    case 6: return <h6 className={headingClasses} data-testid={dataTestId}>{children}</h6>;
    case 7: return <h6 className={headingClasses} data-testid={dataTestId}>{children}</h6>;

    default: return null;
  }
};
